import { Injectable } from '@angular/core';
import { AssetUIModel } from '@thehubz/client/core';
import { Collection } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class CollectionEventsService {
  collectionDataSubject$ = new BehaviorSubject<Collection>({} as Collection);
  collectionAssetDataSubject$ = new BehaviorSubject<AssetUIModel[]>([]);
  collectionAssetCountSubject$ = new BehaviorSubject<number>(0);
  collectionFilterDataSubject$ = new BehaviorSubject<AnyType>({});
  collectionFilterBubblesSubject$ = new BehaviorSubject<AnyType>([]);
  collectionApplyFilterSubject$ = new BehaviorSubject<AnyType>({});
  collectionUpdateFormDataSubject$ = new BehaviorSubject<AnyType>({});
  collectionUpdateSidebar$ = new BehaviorSubject<{ formControlName?: string; fieldData?: AnyType }>({});
  collectionListSearchFilter$ = new BehaviorSubject<string>('');
  removeAllCollectionFilterBubble = new Subject<boolean>();
  removeCollectionFilterBubble = new BehaviorSubject<AnyType>({});
  splitCollectionAssets = new BehaviorSubject<AnyType>(null);
  collectionListChangeView = new BehaviorSubject<string>('');
  collectionListSortBy = new BehaviorSubject<string>('');
  collectionUpdateSubject$ = new BehaviorSubject<AnyType>({});
  collectionsSearchFilterBubbles$ = new BehaviorSubject<AnyType>({});
  collectionsClearSearch = new Subject<boolean>();
  collectionTableDataSubject$ = new BehaviorSubject<AnyType>({});
  collectionsTableDataSubject$ = new BehaviorSubject<AnyType>({});
  collectionsReloadCounterSubject$ = new Subject<{ offset: number; direction?: string; anchorIndex?: number }>(); // Subject, no initial trigger
  collectionsReloadOffsetSubject$ = new Subject<number>();
}
